import http from "../../http";

const BASE = "/resident/api/resident/houseFeeStandard";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
};
